const STORAGE_KEY = 'physioedge.clinicWelcomePending';

function readPending(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writePending(userId: string | null) {
  try {
    if (userId) window.localStorage.setItem(STORAGE_KEY, userId);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private mode / blocked storage — tour still opens via navigation state */
  }
}

/** Mark that this clinic staff account should see the first-login welcome tour. */
export function markClinicWelcomePending(userId: string) {
  writePending(userId);
}

export function clinicWelcomeIsPending(userId: string): boolean {
  return readPending() === userId;
}

export function dismissClinicWelcome(userId: string) {
  if (readPending() === userId) writePending(null);
}
